import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import { getParamAsInt } from "../../../../app/utils";
import RtkqResultViewer from "../../../../components/RtkqResultViewer";
import { SelectList } from "../../../../components/input/SelectList";
import { SelectDevelopmentView } from "../../../../components/input/SelectDevelopmentView";
import { Loading } from "../../../../components/Loading";
import { DownloadButton } from "../../shared/DownloadButton";
import { ScoresByPromptTable } from "./ScoresByPromptTable";
import { ScoresByPromptChart } from "./ScoresByPromptChart";
import { useCoursePromptByPromptReportQuery } from "./coursePromptReportApiSlice";

export default function CourseScoresByPrompt() {
	const { aspUrl } = useAppSelector((state) => state.site);

	const [queryParams] = useSearchParams();
	const promptIdParam = getParamAsInt(queryParams, "promptId") ?? 0;
	const courseId = getParamAsInt(queryParams, "courseId") ?? 0;

	const [promptId, setPromptId] = useState(promptIdParam);

	const [view, setView] = useState("react");

	const result = useCoursePromptByPromptReportQuery({ promptId, courseId });
	const data = result.data;

	const handlePromptChange = (promptId: string) => {
		setPromptId(Number(promptId));
	};

	return (
		<section>
			<div className="flex justify-between">
				<div className="w-3/4">
					<h1>Course Prompt Report</h1>
				</div>
				<SelectDevelopmentView
					value={view}
					setValue={(v) => setView(v as string)}
					simpleListBoxId="viewFilter"
					options={[
						{ value: "react", label: "React" },
						{ value: "raw", label: "Raw Data" },
					]}
					fieldClasses="w-64"
				/>
			</div>
			{view == "react" && (
				<section className="mt-8">
					<h2>Student Scores by Prompt</h2>
					<p className="mt-4">
						The report below displays a list of students who responded to the selected
						prompt and each student’s scores for the most recent draft written to the
						selected prompt. Use the drop-down menu to view the results for a different
						prompt.
					</p>
					<Loading loading={result.isLoading} />
					{data && (
						<>
							<div className="flex justify-between items-end w-full mt-4">
								<SelectList
									className="w-1/4"
									selectListItems={data.allPrompts}
									onChange={handlePromptChange}
								/>
								<DownloadButton
									url={`${aspUrl}/Report/DownloadPromptUsageFilteredByCourseAndPrompt?courseId=${data.courseId}&promptId=${data.promptId}`}
									disabled={data.scoreByWriter.length == 0}
								/>
							</div>
							<ScoresByPromptTable
								className="mt-4"
								promptId={promptId}
								courseId={data.courseId}
								isConstructedResponse={data.isConstructedResponseGenre}
								writerData={data.scoreByWriter}
								classData={data.scoreForCourse}
							/>
							<ScoresByPromptChart
								className="mt-8 p-4 border-2 border-gray-200"
								courseId={data.courseId}
								isConstructedResponse={data.isConstructedResponseGenre}
								writerData={data.scoreByWriter}
								classData={data.scoreForCourse}
							/>
						</>
					)}
				</section>
			)}
			{view == "raw" && <RtkqResultViewer heading="Prompt Report Data" result={result} />}
		</section>
	);
}
